"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var classNames = require("classnames");
var I18n = require("i18n-js");
var auto_offer_modal_1 = require("./auto_offer_modal");
var initialModalState = {
    open: false,
};
function reducer(state, action) {
    switch (action.type) {
        case 'toggleModalOpen':
            return tslib_1.__assign(tslib_1.__assign({}, state), { open: !state.open });
    }
}
function AutoOfferModalButton(_a) {
    var listingId = _a.listingId, offerActive = _a.offerActive;
    var _b = React.useReducer(reducer, initialModalState), modalState = _b[0], dispatch = _b[1];
    return (React.createElement("div", { className: "listing-row__action" },
        React.createElement("button", { className: classNames('listing-row__action__trigger', {
                'listing-row__action__trigger--active': offerActive,
                'listing-row__action__trigger--not-sending': false,
            }), onClick: function () { return dispatch({ type: 'toggleModalOpen' }); } }, I18n.t('discovery.offers.autoOffers.autoOffers')),
        modalState.open && (React.createElement(auto_offer_modal_1.default, { modalIsOpen: true, listingId: listingId, onModalClose: function () { return dispatch({ type: 'toggleModalOpen' }); } }))));
}
exports.AutoOfferModalButton = AutoOfferModalButton;
exports.default = AutoOfferModalButton;
//# sourceMappingURL=auto_offer_modal_button.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/listings/auto_offer_modal_button.js
// module id = JMQD
// module chunks = 20 21